import { __assign } from 'tslib';
import React__default from 'react';
import { Position } from '@keepeek/commons';
import { styled, Box } from '@mui/material';
import clsx from 'clsx';
import Tag from './Tag/index.js';

var PREFIX = "Tags";
var classes = {
    root: "".concat(PREFIX, "-root")
};
var StyledTags = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "tagsPosition"; }
})(function (_a) {
    var tagsPosition = _a.tagsPosition;
    return ({
        display: "flex",
        flexDirection: "column",
        // tags on the left side of the card / player have to be aligned on the left, otherwise on the right
        alignItems: tagsPosition && [Position.TopRight, Position.BottomRight].includes(tagsPosition)
            ? "flex-end"
            : "flex-start"
    });
});
/**
 * Component containing all "Visual Alerts" or "Labels" for a media
 */
var Tags = function Tags(_a) {
    var className = _a.className, tagsData = _a.tagsData, tagsPosition = _a.tagsPosition, titleMinimized = _a.titleMinimized;
    if (!tagsData) {
        return null;
    }
    return (React__default.createElement(StyledTags, { className: clsx("Tags", classes.root, className), tagsPosition: tagsPosition }, tagsData.map(function (tagData, index) { return (React__default.createElement(Tag, __assign({ key: index }, tagData, { titleMinimized: titleMinimized }))); })));
};

export { Tags as default };
//# sourceMappingURL=index.js.map
